/**
 * Mount point. Strict mode + the root component, nothing else.
 *
 * We intentionally do NOT register a service worker in V1 — TMA webviews
 * have inconsistent SW support across iOS/Android Telegram clients, and the
 * inbox depends on a live JWT-bound SSE which doesn't cache anyway.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Missing #root element in index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
